const modelViewers = {
  generationModeSiloRender: 'silo render',
  studioRender: 'Studio Render',
  renderingImage: 'Рендеринг зображення',
  renderingImageDescription1:
    'Вашу модель надіслано на сервер рендерингу під тим самим кутом огляду, який ви задали, і кадровано за співвідношенням сторін, обраним у розділі <accent>Display settings</accent>.',
  renderingImageDescription2:
    'Зараз вона рендериться з високоякісними матеріалами та студійним освітленням — у середньому це займає близько 1 хвилини.',
  renderingImageDescription3:
    'Будь ласка, не закривайте це вікно до завершення рендерингу.',
  lifestyleSceneDescription: 'Згенерувати lifestyle-сцену за допомогою ШІ',
  siloSceneDescription: 'Покращити матеріали моделі на білому тлі',
  closeUpSceneDescription: 'Згенерувати великий план моделі',
  createProductLifestyle: 'Створити lifestyle із 3D-студійного рендеру',
  createProductLifestyleShort: 'Створити студійний lifestyle'
};

export default modelViewers;
